import { createFileRoute } from '@tanstack/react-router'
import { edyOrganizationSearchSchema } from '@/features/edy-organizations/filter-edy-organizations/model/edyOrganizationSearch'
import { EdyOrganizationsPage } from '@/pages/platform-users/ui/EdyOrganizationsPage'

export const Route = createFileRoute('/organizations')({
  validateSearch: edyOrganizationSearchSchema,
  component: EdyOrganizationsPage,
})
